import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState, useRef } from 'react';
import { normalizeTimestamp } from '../../../utils/TimestampManager';
var useTimeThreshold = function useTimeThreshold(endTimestamp) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTwoHoursRemaining = _useState2[0],
    setIsTwoHoursRemaining = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTenMinutesRemaining = _useState4[0],
    setIsTenMinutesRemaining = _useState4[1];
  var timeoutRefs = useRef({});
  useEffect(function () {
    if (!endTimestamp) return;
    var now = Date.now();
    var msUntil2HoursLeft = normalizeTimestamp(endTimestamp) - now - 7200000;
    var msUntil10MinLeft = normalizeTimestamp(endTimestamp) - now - 600000;
    Object.values(timeoutRefs.current).forEach(clearTimeout);
    timeoutRefs.current = {};
    if (msUntil2HoursLeft > 0) {
      timeoutRefs.current.twoHours = setTimeout(function () {
        setIsTwoHoursRemaining(true);
      }, msUntil2HoursLeft);
    } else {
      setIsTwoHoursRemaining(true);
    }
    if (msUntil10MinLeft > 0) {
      timeoutRefs.current.tenMinutes = setTimeout(function () {
        setIsTenMinutesRemaining(true);
      }, msUntil10MinLeft);
    } else {
      setIsTenMinutesRemaining(true);
    }
    return function () {
      Object.values(timeoutRefs.current).forEach(clearTimeout);
      timeoutRefs.current = {};
    };
  }, [endTimestamp]);
  return {
    isTwoHoursRemaining: isTwoHoursRemaining,
    isTenMinutesRemaining: isTenMinutesRemaining
  };
};
export default useTimeThreshold;